import { HttpParams } from '@angular/common/http';
import { CeiTablePage, CeiTablePageRequest } from '@cei-ufg/ngx-arquitetura-cei-frontend';

/** Monta query string DRF (`page`, `page_size`, `ordering`) a partir da requisição da tabela CEI. */
export function montarHttpParamsPaginacao(request: CeiTablePageRequest): HttpParams {
  let params = new HttpParams()
    .set('page', String(request.page))
    .set('page_size', String(request.pageSize));

  if (request.sortField && request.sortDirection) {
    const prefixo = request.sortDirection === 'desc' ? '-' : '';
    params = params.set('ordering', `${prefixo}${request.sortField}`);
  }

  return params;
}

/** Extrai parâmetros de paginação compatíveis com serviços OpenAPI do `ngx-cei-seguranca`. */
export function paraRequisicaoPaginacaoOpenApi(request: CeiTablePageRequest): {
  page: number;
  pageSize: number;
} {
  return {
    page: request.page,
    pageSize: request.pageSize,
  };
}

/** Resposta paginada mínima aceita pela normalização CEI. */
export type RespostaPaginadaApi<T> =
  | T[]
  | {
      results?: T[];
      count?: number;
    };

/** Normaliza resposta paginada DRF ou array simples para o contrato `CeiTablePage`. */
export function normalizarPaginaApi<T>(resposta: RespostaPaginadaApi<T>): CeiTablePage<T> {
  if (Array.isArray(resposta)) {
    return {
      results: resposta,
      count: resposta.length,
    };
  }

  return {
    results: resposta.results ?? [],
    count: resposta.count,
  };
}
